import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

/**
 * @param {Record<string, string>} props
 * @returns {{ SUCCESS: string; FAILED: string; PENDING: string; }}
 */
export const statusColor = props => {
	return {
		"SUCCESS" : props.tertiarySuccessGreen,
		"FAILED"  : props.tertiaryErrorRed,
		"PENDING" : props.tertiaryYellow
	};
};

export default createStyles ( ( theme, props ) => {

	return {
		parent: {
			display       : "flex",
			flexDirection : "column",
			height        : "100%"
		},
		text: {
			marginBlock  : "2.4rem",
			marginInline : "1.6rem"
		},
		historyList: {
			[rooterMediaQuery.mobile]: {
				maxHeight: "unset"
			},

			maxHeight     : "70dvh",
			minHeight     : "50dvh",
			width         : "100%",
			position      : "relative",
			paddingInline : "1.6rem",
			listStyleType : "none",
			overflow      : "auto",
			display       : "flex",
			flexDirection : "column",
			gap           : "2rem"
		},
		listItem: {
			"&:last-child": {
				marginBottom: "12rem"
			}
		},
		listItemWrapper: {
			width: "100%"
		},
		itemLabel: {
			width: "100%"
		},
		listItemContent: {
			display        : "flex",
			justifyContent : "space-between",
			alignItems     : "flex-start",
			position       : "relative",
			paddingBottom  : "1.6rem",
			":after"       : {
				content      : "''",
				position     : "absolute",
				right        : "-1.6rem",
				bottom       : "0",
				left         : "5rem",
				borderBottom : `1px solid ${ theme.other.paletteNew.darkModeWhite20 }`
			},

			[rooterMediaQuery.mobile]: {
				":after": {
					content      : "''",
					position     : "absolute",
					right        : "-1.6rem",
					bottom       : "0",
					left         : "5rem",
					borderBottom : `1px solid ${ theme.other.paletteNew.darkModeWhite20 }`
				}
			}
		},
		icon: {
			background                : theme.other.paletteNew.secondaryDarkGrey20,
			borderRadius              : "50%",
			aspectRatio               : "1/1",
			padding                   : "0.8rem",
			width                     : "4rem",
			height                    : "4rem",
			[rooterMediaQuery.mobile] : {
				padding : "1rem",
				height  : "4.4rem",
				width   : "4.4rem"
			}
		},
		left: {
			display       : "flex",
			gap           : "0.8rem",
			flexDirection : "column",
			flex          : "1",
			marginInline  : "2rem"
		},
		right: {
			paddingRight  : "1rem",
			display       : "flex",
			gap           : "0.8rem",
			alignItems    : "flex-start",
			flexDirection : "row",

			[rooterMediaQuery.desktop]: {
				gap: "2rem"
			}
		},
		priceContainer: {
			display       : "flex",
			flexDirection : "column",
			gap           : "0.8rem",
			alignItems    : "flex-end"
		},
		threeDotsIcon: {
			padding      : "1.5rem",
			borderRadius : "0.5rem"
		},
		sellPrice: {
			textDecoration: "line-through"
		},
		rightTop: {
			gap        : "0.5rem",
			display    : "flex",
			alignItems : "baseline"
		},
		readingButton: {
			fontSize : "1.2rem",
			// padding  : important ( "0.6rem 1.8rem" ),
			width    : "fit-content"
		},
		status: {
			color         : statusColor ( theme.other.paletteNew )[props?.status.toUpperCase ()],
			textTransform : "capitalize"
		},
		emptyView: {
			height         : "100%",
			display        : "flex",
			flexDirection  : "column",
			gap            : "1.6rem",
			padding        : "1rem 8rem",
			textAlign      : "center",
			justifyContent : "center",
			alignItems     : "center"
		},
		watchIcon: {
			width  : "10rem",
			height : "10rem"
		}
	};
} );
